import { FixedTextInput } from 'pages/wizard/styles';
import { useTheme } from 'styled-components';
import { Theme } from 'styles/theme';

export const FixedTextInputComponent: React.FunctionComponent<{
  value: any;
  propertyName: string;
  onKeyDown?: any;
  onPaste?: any;
  onChange?: any;
  onChangeEpd: any;
  disabled: boolean;
  style?: any;
  placeholder?: string;
  type?: string;
  min?: string;
  step?: string;
}> = ({ value, propertyName, onKeyDown, onPaste, onChange, onChangeEpd, disabled, style, placeholder, type, min, step }) => {
  const theme = useTheme() as Theme;
  const shouldShowPlaceholder = !disabled && !value;
  const combinedStyle: React.CSSProperties = {
    ...style,
    color: disabled ? theme.colors.elementDisabledTextColor : style?.color ?? 'inherit',
  };

  return (
    <FixedTextInput
      style={combinedStyle}
      type={type}
      min={min}
      step={step}
      defaultValue={value}
      onKeyDown={onKeyDown}
      onPaste={onPaste}
      onChange={onChange}
      onBlur={(e: React.ChangeEvent<HTMLInputElement>) =>
        e.currentTarget.value !== value?.toString() && onChangeEpd(propertyName, e.currentTarget.value)
      }
      disabled={disabled}
      placeholder={shouldShowPlaceholder ? placeholder : ''}
    />
  );
};
